import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.82 1.016c.178-.032.361-.016.532.048l8 3.013a1 1 0 0 1 .648.936v5.834c0 5.678-3.655 10.006-8.615 12.076a1 1 0 0 1-.77 0C6.655 20.853 3 16.525 3 10.847V5.013a1 1 0 0 1 .647-.936l8-3.013zm3.888 8.277a1 1 0 0 0-1.415 0l-3.292 3.293-1.293-1.293a1 1 0 0 0-1.415 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0 0-1.414"
    }, null, -1)
  ]))]))
}
export default { render: render }